
    import { signUp } from '../../lib/auth.js';
    import { supabase } from '../../lib/supabase.js';

    const form = document.getElementById('signupForm');
    const errorMessage = document.getElementById('errorMessage');
    const submitBtn = document.getElementById('submitBtn');

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const fullName = document.getElementById('fullName').value.trim();
      const email = document.getElementById('email').value.trim();
      const password = document.getElementById('password').value;
      const confirmPassword = document.getElementById('confirmPassword').value;

      errorMessage.classList.add('hidden');
      errorMessage.textContent = '';

      if (password !== confirmPassword) {
        errorMessage.textContent = 'Passwords do not match';
        errorMessage.classList.remove('hidden');
        return;
      }

      submitBtn.disabled = true;
      submitBtn.innerHTML = `
        <iconify-icon icon="solar:spinner-linear" class="animate-spin text-lg mr-2"></iconify-icon>
        Reserving your spot...
      `;

      try {
        const { data, error } = await signUp(email, password);

        if (error) {
          errorMessage.textContent = error.message || 'An error occurred during sign up';
          errorMessage.classList.remove('hidden');
          submitBtn.disabled = false;
          submitBtn.innerHTML = 'Reserve my spot';
          return;
        }

        if (data.user) {
          // Save full name to auth metadata
          await supabase.auth.updateUser({ data: { full_name: fullName } });

          // Add to waitlist table (ignore if already exists)
          await supabase.from('waitlist').insert({ email, full_name: fullName }).maybeSingle();

          window.location.href = '../../dashboard.html';
        }
      } catch (err) {
        errorMessage.textContent = 'An unexpected error occurred. Please try again.';
        errorMessage.classList.remove('hidden');
        submitBtn.disabled = false;
        submitBtn.innerHTML = 'Reserve my spot';
      }
    });
  